if (!customElements.get('amielle-inspirations')) {
  customElements.define('amielle-inspirations', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('.amielle-inspirations__viewport');
      this.track = this.querySelector('.amielle-inspirations__track');
      this.group = this.track?.firstElementChild;
      if (!this.group || this.group.children.length < 2) return;
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.duration = parseFloat(getComputedStyle(this).getPropertyValue('--inspiration-duration')) || 90;
      for (let i = 0; i < 2; i++) {
        const duplicate = this.group.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        duplicate.setAttribute('inert', '');
        duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
        duplicate.querySelectorAll('img').forEach(img => img.alt = '');
        this.track.append(duplicate);
      }
      this.querySelector('.amielle-inspirations__controls').hidden = false;
      this.toggle.addEventListener('click', () => this.hasAttribute('data-running') ? this.manual() : this.start(), options);
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.manual();
        this.normalize();
        this.viewport.scrollBy({ left: Number(button.dataset.direction) * (this.group.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.group).gap)), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }, options));
      this.viewport.addEventListener('pointerdown', event => {
        this.manual();
        this.normalize();
        if (event.pointerType === 'mouse' && event.button === 0) {
          this.drag = { x: event.clientX, left: this.viewport.scrollLeft };
          this.viewport.setPointerCapture(event.pointerId);
          event.preventDefault();
        }
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        if (this.drag) this.viewport.scrollLeft = this.drag.left + this.drag.x - event.clientX;
      }, options);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.viewport.addEventListener(type, () => this.drag = null, options));
      this.viewport.addEventListener('wheel', () => { this.manual(); this.normalize(); }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); this.manual(); this.normalize();
        const width = this.group.getBoundingClientRect().width;
        if (event.key === 'Home' || event.key === 'End') this.viewport.scrollLeft = event.key === 'Home' ? width : width * 2 - this.viewport.clientWidth;
        else this.viewport.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * this.viewport.clientWidth * .75, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }, options);
      this.motion.addEventListener('change', () => this.manual(), options);
      document.addEventListener('visibilitychange', () => this.suspend(), options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.suspend(); });
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', event => {
        this.manual();
        const card = event.target.closest('.amielle-inspirations__card');
        if (card) this.viewport.scrollLeft = card.offsetLeft - this.track.offsetLeft;
      }, options);
      if (this.dataset.autoplay === 'true' && !this.motion.matches && !window.Shopify?.designMode) this.start();
      else this.setButton(false);
    }
    suspend() { this.toggleAttribute('data-suspended', !this.visible || document.hidden); }
    setButton(running) {
      this.toggle.setAttribute('aria-pressed', String(!running));
      this.toggle.setAttribute('aria-label', running ? 'Mettre les images en pause' : 'Reprendre le défilement');
      this.toggle.querySelector('[data-pause]').hidden = !running;
      this.toggle.querySelector('[data-play]').hidden = running;
      this.toggle.hidden = this.motion.matches;
    }
    start() {
      if (this.motion.matches) return;
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      const offset = this.viewport.scrollLeft % width;
      this.style.setProperty('--inspiration-delay', `${-offset / width * this.duration}s`);
      this.viewport.scrollLeft = 0;
      this.setAttribute('data-running', '');
      this.setButton(true);
      this.suspend();
    }
    manual() {
      if (this.hasAttribute('data-running')) {
        const transform = getComputedStyle(this.track).transform;
        const offset = transform === 'none' ? 0 : -new DOMMatrixReadOnly(transform).m41;
        this.removeAttribute('data-running');
        this.viewport.scrollLeft = offset + this.group.getBoundingClientRect().width;
      }
      this.setButton(false);
    }
    normalize() {
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      if (this.viewport.scrollLeft < width * .25) this.viewport.scrollLeft += width;
      else if (this.viewport.scrollLeft > width * 1.75) this.viewport.scrollLeft -= width;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.abort = null;
      this.track?.querySelectorAll('[aria-hidden="true"]').forEach(node => node.remove());
      this.removeAttribute('data-running');
    }
  });
}
